type DateNavigatorProps = {
  date: string;
  onDateChange: (date: string) => void;
  onPrevious: () => void;
  onNext: () => void;
  onToday: () => void;
};

export default function DateNavigator({
  date,
  onDateChange,
  onPrevious,
  onNext,
  onToday,
}: DateNavigatorProps) {
  return (
    <div className="date-navigation">
      <button
        type="button"
        onClick={onPrevious}
        aria-label="Dia anterior"
      >
        ‹
      </button>

      <input
        type="date"
        value={date}
        onChange={(event) =>
          onDateChange(event.target.value)
        }
      />

      <button
        type="button"
        onClick={onNext}
        aria-label="Próximo dia"
      >
        ›
      </button>

      <button
        type="button"
        onClick={onToday}
      >
        Hoje
      </button>
    </div>
  );
}